import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import Button from '../../generic/Button/Button';
import { BUTTON_TYPE } from '../../generic/Button/button-constants';
import Flex from '../../generic/Flex';

type RangedToggleProps = {
  filterEnabled: boolean;
  range: { min: number; max: number };
  toggleFilter: () => void;
  setRange: (min: number, max: number) => void;
  text: string;
};

const RangedToggle: VoidFunctionComponent<RangedToggleProps> = ({
  filterEnabled,
  range,
  toggleFilter,
  setRange,
  text,
}) => {
  const onChangeMin = useCallback((e) => {
    setRange(Number(e.target.value), range.max);
  }, [range.max, setRange]);

  const onChangeMax = useCallback((e) => {
    setRange(range.min, Number(e.target.value));
  }, [range.min, setRange]);

  return (
    <div className="contributor-count-area">
      <div className="range-toggle-button">
        <Button
          type={filterEnabled ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.OUTLINE}
          onClick={toggleFilter}
        >
          {text}
        </Button>
      </div>
      {/* TODO Change these inputs to be our LabeledNumberInput component after NumberInput typings have been fixed. */}
      <Flex direction="column">
        <p>
          <span className="range-toggle-label">min:</span>
          <input type="number" value={range.min} onChange={onChangeMin} />
        </p>
        <p>
          <span className="range-toggle-label">max:</span>
          <input type="number" value={range.max} onChange={onChangeMax} />
        </p>
      </Flex>
    </div>
  );
};

export default RangedToggle;
